module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [(!_vm.showr) ? _c('div', {
    staticClass: "text-center pcsp"
  }, [_c('h1', [_vm._v("You have not made any purchases yet")]), _vm._v(" "), _c('p', [_vm._v("this page displays all receipts click cart to view cart")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-type-h",
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Start Shopping!")])], 1) : _vm._e(), _vm._v(" "), (_vm.showr) ? _c('div', {
    staticClass: "pcsp"
  }, [_c('h1', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("My Receipts")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.ordersinfo), function(order) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(order.order_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_date.split(" ").shift()))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("Php " + _vm._s(_vm.formatMoney(order.price)))]), _vm._v(" "), _c('td', {
      staticClass: "admin-table-row-options"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.viewreceipt(order.order_no)
        }
      }
    }, [_vm._v("View")])])])
  })], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showReceipt) ? _c('orderreceipt', {
    attrs: {
      "orderinfo": _vm.orderinfo,
      "ordercode": _vm.currentOrderCode
    },
    on: {
      "exitReceipt": _vm.exitReceipt
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "button-type-f text-left",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Export Receipts")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Order Code:")]), _vm._v(" "), _c('th', [_vm._v("Date:")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Price:")]), _vm._v(" "), _c('th', [_vm._v("Receipt:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4093c33b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User.vue
// module id = 150
// module chunks = 0